import LoyaltyBalanceButtonSFC from "./LoyaltyBalanceButton.vue";
export const LoyaltyBalanceButton = LoyaltyBalanceButtonSFC;
